// Chart color system — validated categorical/sequential/diverging palette +
// chart chrome tokens, shared by every Recharts instance in the app. See the
// `dataviz` skill for the method; this palette passed
// `scripts/validate_palette.js` against a white (#FFFFFF) chart surface.

// Fixed-order categorical palette. Assign by array index in declaration
// order — never cycle/reorder per chart, that's what keeps adjacent series
// distinguishable for colorblind readers.
export const CHART_CATEGORICAL = [
  "#2a78d6", // 1 blue      — primary series / "actual" / current
  "#eb6834", // 2 orange    — secondary series / warning-adjacent
  "#1baf7a", // 3 aqua      — tertiary series
  "#eda100", // 4 yellow    — quaternary
  "#e87ba4", // 5 magenta
  "#008300", // 6 green
  "#4a3aa7", // 7 violet    — "predicted" / AI series
  "#e34948", // 8 red       — risk / critical series
];

export const chartColor = (i) => CHART_CATEGORICAL[i % CHART_CATEGORICAL.length];

// Single-hue sequential ramp (blue), light -> dark, for gauges/heat/magnitude.
export const CHART_SEQUENTIAL = {
  100: "#cde2fb", 150: "#b7d3f6", 200: "#9ec5f4", 250: "#86b6ef",
  300: "#6da7ec", 350: "#5598e7", 400: "#3987e5", 450: "#2a78d6",
  500: "#256abf", 550: "#1c5cab", 600: "#184f95", 650: "#104281", 700: "#0d366b",
};

// Diverging pair (blue <-> red) with a neutral gray midpoint, for
// above/below-baseline encodings.
export const CHART_DIVERGING = { negative: "#e34948", neutral: "#f0efec", positive: "#2a78d6" };

// Status palette — reserved for state (good/warning/serious/critical), never
// reused as a categorical series color. Matches src/data/statusColors.js.
export const CHART_STATUS = {
  good: "#0ca30c",
  warning: "#fab219",
  serious: "#ec835a",
  critical: "#d03b3b",
};

// Chart chrome — grid, axis, tooltip, ink tokens shared by every chart so
// CartesianGrid/PolarGrid stroke and axis tick color stop drifting per page.
export const CHART_CHROME = {
  grid: "#e1e0d9",
  axis: "#c3c2b7",
  tickText: "#898781",
  ink: "#0b0b0b",
  inkSecondary: "#52514e",
};

// Shared Recharts axis/grid prop bundles — spread directly onto
// <CartesianGrid>/<XAxis>/<YAxis>/<PolarGrid> so every chart gets identical
// chrome without repeating prop literals per page.
export const gridProps = { strokeDasharray: "3 3", stroke: CHART_CHROME.grid };
export const axisTick = { fontSize: 10, fill: CHART_CHROME.tickText };
export const axisLineProps = { stroke: CHART_CHROME.axis };
export const legendStyle = { fontSize: 11, color: CHART_CHROME.inkSecondary };
